export default{
    userData:{

    },
    jwt:"",
    userInfo:{
        
    },
    environment:"development"
}